// import type { ChatOptions, ReceivedChatMessage } from '@livekit/components-core';
// import { setupChat } from '@livekit/components-core';
// import { useRoomContext } from '../context';
// import { useObservableState } from './internal/useObservableState';
import { LocalVideoTrack } from 'livekit-client'

import { BackgroundProcessor } from '@/src/processor'

import { BgEffect } from '@/src/lib/types'

/**
 * The `useChat` hook provides chat functionality for a LiveKit room.
 * It returns a simple `send` function to send chat messages and an array of `chatMessages` to hold received messages.
 * It also returns a `update` function that allows you to implement message-edit functionality.
 * @remarks
 * It is possible to pass configurations for custom message encoding and decoding and non-default topics on which to send the messages.
 * @public
 */

let processor

export async function useToggleTrackProcessor(
  track: LocalVideoTrack,
  currentBgEffect: BgEffect | null,
) {
  if (!track) return
  //@ts-ignore нет интерфейса для процессора
  if (track.processor?.name === currentBgEffect?.type) return
  const trackHandler = async () => {
    if (currentBgEffect?.type === 'none') {
      //@ts-ignore нет интерфейса для процессора
      if (track.processor?.name) {
        await track.stopProcessor()
        processor = undefined
      }
      return
    } else {
      //@ts-ignore нет интерфейса для процессора
      if (!track.processor?.name) {
        processor = BackgroundProcessor(currentBgEffect.options)
        await track.setProcessor(processor, true)
        processor.updateProcessorName(currentBgEffect.type)
      } else {
        processor.updateTransformerOptions(currentBgEffect.options)
        processor.updateProcessorName(currentBgEffect.type)
      }
    }
  }
  await trackHandler()

  return track
}
